import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Stepper, Step } from "@progress/kendo-react-layout";
import { REWARDS_DEFINITION_ADD } from "../../../routes";

const items = [
  {
    label: "Reward",
    value: 0,
  },
  {
    label: "Review",
    value: 1,
  }
];


export const RewardInventoryDefinitionSteps = (props) => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const handleChange = (e) => {
    // e.preventDefault();
    if (e.value != 0) {
      if (props.checkMandatoryFields()) return;
    }
    if (query.get("id")) {
      props.setState(e.value);
      query.set("state", e.value);

      navigate(REWARDS_DEFINITION_ADD + "?" + query.toString());
    } else {
      props.handleSubmit(false);
    }
  };

  return (
    <>
      <div className="shuttle_bus_booking-steps-group">
        <div className="progress-steps-inside-group">
          <Stepper
            className="inventory_steps"
            value={props.state}
            items={items}
            // item={CustomStep}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
    </>
  );
};